module.exports = __webpack_public_path__ + "static/media/ico-fader.1e98c118.svg";